import { Injectable } from '@angular/core';
import { ServicoEstadoTerminalLocal } from '../../core/terminal/servico-estado-terminal-local';

export interface ContextoAberturaCameraRegistrador {
  empregadorSelecionado: string;
  terminalPublico: boolean;
  terminalAutorizado: boolean;
  online: boolean;
  terminalToken: string;
  cacheBiometricoValido: boolean;
}

export interface ResultadoAberturaCameraRegistrador {
  permitido: boolean;
  mensagem?: string;
  exigeAtualizacaoCacheOffline: boolean;
}

@Injectable({ providedIn: 'root' })
export class ServicoValidacaoAberturaCameraRegistrador {
  constructor(private readonly servicoEstadoTerminalLocal: ServicoEstadoTerminalLocal) {}

  avaliar(contexto: ContextoAberturaCameraRegistrador): ResultadoAberturaCameraRegistrador {
    if (!contexto.empregadorSelecionado) {
      return this.negado(
        contexto.terminalPublico
          ? 'Terminal nao configurado para este dominio.'
          : 'Selecione um empregador para registrar o ponto.'
      );
    }

    if (contexto.terminalPublico && !contexto.terminalAutorizado) {
      return this.negado('Terminal nao autorizado. Informe o codigo de ativacao.');
    }

    if (contexto.terminalPublico && !contexto.online) {
      const avaliacaoTerminal = this.servicoEstadoTerminalLocal.avaliarOperacaoOffline(contexto.terminalToken);
      if (!avaliacaoTerminal.permitido || !contexto.cacheBiometricoValido) {
        return {
          permitido: false,
          mensagem: avaliacaoTerminal.motivo || 'Registro offline indisponivel. Conecte a internet para atualizar o terminal.',
          exigeAtualizacaoCacheOffline: true
        };
      }
    }

    return {
      permitido: true,
      exigeAtualizacaoCacheOffline: false
    };
  }

  deveAtualizarCacheAntesDeAvaliar(contexto: ContextoAberturaCameraRegistrador) {
    return contexto.terminalPublico && !contexto.online;
  }

  private negado(mensagem: string): ResultadoAberturaCameraRegistrador {
    return {
      permitido: false,
      mensagem,
      exigeAtualizacaoCacheOffline: false
    };
  }
}
